import { render, staticRenderFns } from "./table-of-contents.vue?vue&type=template&id=55009b1c&scoped=true&"
import script from "./table-of-contents.vue?vue&type=script&lang=js&"
export * from "./table-of-contents.vue?vue&type=script&lang=js&"
import style0 from "./table-of-contents.vue?vue&type=style&index=0&id=55009b1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55009b1c",
  null
  
)

export default component.exports